import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Typography,
  IconButton,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import WarnModal from "components/DeleteModal";
import { useAddFaqMutation } from "services/settings";
import ShowToast from "components/MDToast";
import { useLazyGetAllFaqQuery } from "services/settings";
import { useDeleteFaqMutation } from "services/settings";
import useTranslation from "hooks/Translation";

function FAQSection({ getAllFaqsHandler, faq }) {
  const t = useTranslation();
  const [addFaqsMutation] = useAddFaqMutation();
  const [getAllFaqs] = useLazyGetAllFaqQuery();
  const [deleteFaq] = useDeleteFaqMutation();

  const [newQuestion, setNewQuestion] = useState("");
  const [newAnswer, setNewAnswer] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [selectedLang, setSelectedLang] = useState("");

  const [loading, setLoading] = useState(false);
  const handleLanguageChange = (event) => {
    setSelectedLang(event.target.value);
  };

  const handleDeleteFaq = async (id) => {
    try {
      const response = await deleteFaq(id).unwrap();
      if (response?.status === 200) {
        ShowToast("Faq deleted successfully", "success");
        getAllFaqsHandler();
        setOpen(false);
      }
    } catch (error) {
      console.log(error, "errror");
      ShowToast(error?.data?.message || "", "error");
    }
  };

  const handleAddFaq = async () => {
    const newFaq = {
      question: newQuestion,
      answer: newAnswer,
      language: Number(selectedLang),
    };

    if (!selectedLang?.length) {
      ShowToast("Please select a language", "error");
      return;
    } else if (!newQuestion?.length) {
      ShowToast("Please add question", "error");
      return;
    } else if (!newAnswer?.length) {
      ShowToast("Please add answer", "error");
      return;
    }

    try {
      const res = await addFaqsMutation(newFaq).unwrap();
      if (res?.status === 200) {
        getAllFaqsHandler();
        ShowToast("Faq added successfully");
        setNewQuestion("");
        setNewAnswer("");
        setSelectedLang("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={{ margin: "0 auto" }}>
      {/* Add FAQ Section */}

      <MDTypography variant="h4" mb={2}>
        {t.main.addFaq}
      </MDTypography>
      <MDBox>
        <MDTypography variant="subtitle2" className="custom_label">
          {t.main.selectLang}
        </MDTypography>
        <FormControl fullWidth>
          <Select
            className="select_div"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            displayEmpty
            value={selectedLang}
            onChange={handleLanguageChange}
            // error={
            //   formik.touched.industry_type &&
            //   formik.errors.industry_type
            // }
            sx={{
              border: "1px solid grey", // Add a custom border color
              borderRadius: "6px", // Optional: Add border radius for styling
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "grey", // Adjust border color for the outlined variant
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "grey", // Border color on hover
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "grey", // Border color when focused
              },
            }}
          >
            <MenuItem value="" disabled>
              {t.main.select}
            </MenuItem>

            <MenuItem value={"1"}>{t.main.english}</MenuItem>
            <MenuItem value={"2"}>{t.main.russian}</MenuItem>
            <MenuItem value={"3"}>{t.main.arabic}</MenuItem>
          </Select>
        </FormControl>

        <MDTypography variant="subtitle2" className="custom_label" mt={1}>
          {t.main.question}
        </MDTypography>
        <MDInput
          type="text"
          placeholder={t.main.question}
          variant="outlined"
          fullWidth
          onChange={(val) => setNewQuestion(val.target.value.trimStart())}
          value={newQuestion}
        />
        <MDTypography variant="subtitle2" className="custom_label" mt={1}>
          {t.main.answer}
        </MDTypography>
        <MDInput
          type="text"
          placeholder={t.main.answer}
          variant="outlined"
          fullWidth
          onChange={(val) => setNewAnswer(val.target.value.trimStart())}
          value={newAnswer}
        />

        <MDBox mt={2}>
          <MDButton
            variant="gradient"
            color="success"
            disabled={
              !newQuestion?.length ||
              !newAnswer?.length ||
              !selectedLang?.length
            }
            onClick={() => handleAddFaq()}
          >
            {t.main.addFaq}
          </MDButton>
        </MDBox>
      </MDBox>

      {/* FAQ List */}

      <MDBox>
        {faq?.length ? (
          <MDTypography variant="h4" sx={{ marginTop: 2 }} mb={2}>
            {t.main.list}
          </MDTypography>
        ) : (
          ""
        )}

        {faq?.map((faq) => (
          <Accordion key={faq?.id} style={{ marginBottom: "10px" }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography style={{ flexGrow: 1 }}>{faq?.question}</Typography>
              <IconButton
                onClick={(e) => {
                  setOpen(true);
                  setSelectedId(faq.id);
                }}
                size="small"
                edge="end"
              >
                <DeleteIcon />
              </IconButton>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{faq?.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
        <WarnModal
          open={open}
          setOpen={setOpen}
          handleDelete={() => handleDeleteFaq(selectedId)}
          name="Faq"
        />
      </MDBox>
    </div>
  );
}

export default React.memo(FAQSection);
